<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberTest' }">我的考试</router-link>
      <span class="slash">/</span>
      <span class="current">{{ testInfo.test_name }}</span>
    </div>
    <div class="main-content clearfix">
      <div class="f-left questions">
        <el-scrollbar ref="scroll" style="height: calc(100vh - 148px)">
          <div class="paper-head">
            <div class="paper-title" :title="testInfo.test_name">
              {{ testInfo.test_name }}
            </div>
            <div class="paper-info">
              <div
                class="paper-info-class"
                v-for="item in testInfoList"
                :key="item.id"
              >
                <label class="label">{{ item.label }}：</label>
                <label class="value" :class="`type-${item.type}`">
                  {{ item.value }}{{ item.unit }}
                </label>
                <span
                  v-if="
                    item.id == 'submit_time' &&
                    report_list &&
                    report_list.length > 1
                  "
                >
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        :command="item.id"
                        v-for="item in report_list"
                        :key="item.id"
                      >
                        {{ item.submit_time }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
            </div>
            <div class="test-status">
              <div
                class="test-grade"
                v-if="testInfo.test_status == 1 || testInfo.test_status == 3"
              >
                <div style="text-align: center">
                  {{ testInfo.score }}
                </div>
                <img src="../../images/member/Vector@2x.png" />
              </div>
              <div class="status-icon" v-if="testInfo.test_status == 2">
                <img src="../../images/member/approve-no.png" />
              </div>
            </div>
          </div>

          <template v-for="ques in questionList">
            <Question
              v-if="showQuestion[ques.index]"
              :class="{
                'question-sub-first':
                  ques.parent_ques_stem && ques.is_sub_first,
                'question-sub-last': ques.parent_ques_stem && ques.is_sub_last,
                'question-sub': ques.parent_ques_stem,
              }"
              :isFile="2"
              :key="ques.question_id"
              :ques="ques"
              :answer="answer"
              :readonly="true"
              :hasAnalysis="true"
              shotAnswerEditable
              from="analysis"
              :testModel="true"
              :showAllParentStem="false"
              :autoMathJax="false"
            ></Question>
            <div v-else :id="ques.index" :key="ques.question_id"></div>
          </template>
          <div ref="placeholder"></div>
        </el-scrollbar>
      </div>
      <div
        ref="right"
        class="f-right"
        :style="{
          position: fixed ? 'fixed' : 'static',
          right: fixedRight + 'px',
          top: '70px',
        }"
      >
        <div class="answer-view">
          <div class="title">
            <span>答题卡</span>
            <span class="q-num">共{{ questionList.length }}题</span>
          </div>
          <div class="legend">
            <span class="num num-1"></span>
            <span class="text">正确</span>
            <span class="num num-2"></span>
            <span class="text">错误</span>
            <span
              class="num num-4"
              :class="[
                testInfo.audit &&
                testInfo.audit == 1 &&
                testInfo.test_status == 2
                  ? 'noApprove'
                  : '',
                testInfo.audit &&
                testInfo.audit == 1 &&
                testInfo.test_status == 1
                  ? 'approve'
                  : '',
              ]"
            ></span>
            <span
              class="text"
              v-if="
                testInfo.audit &&
                testInfo.audit == 1 &&
                testInfo.test_status == 1
              "
            >
              已批阅
            </span>
            <span
              class="text"
              v-else-if="
                testInfo.audit &&
                testInfo.audit == 1 &&
                testInfo.test_status == 2
              "
            >
              待批阅
            </span>
            <span class="text" v-else>主观题</span>
            <span class="num num-3"></span>
            <span class="text">未作答</span>
          </div>
          <div class="nums">
            <template v-if="hasSection">
              <template v-for="item in scantron.data">
                <template v-if="!checked || item.onlyErrorCount > 0">
                  <div class="section" :key="'section-' + item.id">
                    {{ item.name }}
                  </div>
                  <div :key="'nums-' + item.id">
                    <template v-for="ques in item.child">
                      <a
                        v-if="!checked || ques.onlyError"
                        href="javascript:void(0)"
                        class="num"
                        :class="[
                          'num-' + ques.status,
                          testInfo.audit == 1
                            ? `approve-${ques.is_review}`
                            : '',
                        ]"
                        :key="ques.sort"
                        @click="scrollTo(ques.sort, ques)"
                      >
                        {{ ques.sort }}
                      </a>
                    </template>
                  </div>
                </template>
              </template>
            </template>
            <template v-else>
              <a
                href="javascript:void(0)"
                class="num"
                :class="[
                  'num-' + ques.status,
                  testInfo.audit == 1 ? `approve-${ques.is_review}` : '',
                ]"
                :key="ques.sort"
                v-for="ques in scantron.data"
                @click="scrollTo(ques.sort)"
              >
                {{ ques.sort }}
              </a>
            </template>
          </div>
        </div>
        <div class="filter">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="filter-text">只看错题</span>
        </div>
        <div class="btn-retry" @click="goRepeat">返回</div>
      </div>
    </div>
    <LimitModal ref="limitModal" />
  </div>
</template>
<script>
import Question from "@/components/ques/Question";
export default {
  name: "TestAnalysis",
  components: {
    Question,
  },
  props: {
    reportType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: true,
      id: this.$route.params.id, //报告id
      testInfo: {}, //试卷详情
      report_list: [], //报告list
      testInfoList: [
        {
          id: "nickname",
          label: "考生",
          value: "",
          unit: "",
        },
        {
          id: "answer_time",
          label: "用时",
          value: "",
          unit: "",
        },
        {
          id: "is_pass",
          label: "考试结果",
          value: "",
          unit: "",
        },
        {
          id: "sum_score",
          label: "试卷总分",
          value: "",
          unit: "分",
        },
        {
          id: "user_score",
          label: "客观题得分",
          value: "",
          unit: "分",
        },
        {
          id: "subjective_score",
          label: "主观题得分",
          value: "",
          unit: "分",
        },
        {
          id: "submit_time",
          label: "交卷时间",
          value: "",
          unit: "",
        },
      ],
      list: [], //题目列表
      visible: false,
      questionType: "",
      answer: {},
      fixed: false,
      fixedRight: 0,
      scantron: { list: [] }, //右侧答题卡列表
      section: {},
      showQuestion: {},
      ids: [],
      scrollbarWrap: null,
    };
  },
  watch: {
    async $route() {
      await this.$nextTick();
      const id = this.$route.params.id;
      this.id = id;
      await this.initData(id);
    },
  },
  computed: {
    hasSection() {
      if (this.scantron.data.length == 0) {
        return false;
      }
      return !!this.scantron.data[0].child;
    },
    questionList() {
      if (this.checked) {
        return this.list.filter(item => item.status == 2 || item.status == 4);
      }
      return this.list;
    },
  },
  async created() {
    this.initData(this.id);
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollbarWrap = this.$refs.scroll.$el.querySelector(
        ".el-scrollbar__wrap",
      );
      this.scrollbarWrap.addEventListener("scroll", this.showContent);
      document.addEventListener("scroll", this.setFixed);
      document.addEventListener("resize", this.setFixed);
    });
  },
  beforeDestroy() {
    this.scrollbarWrap.removeEventListener("scroll", this.showContent);
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    //获取页面值信息，处理数据
    async initData(id) {
      let data = await this.$http.get(`/api/app/testDetail/report/${id}`);
      data.report_info.answer_time = this.$actionTool.timeMeter(
        data.report_info.answer_time,
        3,
      );
      data.report_info.submit_time = this.$actionTool.ts(
        data.report_info.submit_time,
        "yearminute",
      );
      //报告列表
      this.report_list = data.report_list.map(item => ({
        ...item,
        submit_time: this.$actionTool.ts(item.submit_time, "yearminute"),
      }));
      //试卷信息
      this.testInfo = data.report_info || {};
      this.testInfoList.forEach(i => {
        i.value = data.report_info[i.id];
        i.unit = data.report_info[i.id] == "-" ? "" : i.unit;
        //主观题
        if (i.id == "subjective_score") {
          //需要批阅
          if (this.testInfo.audit == "1") {
            i.label = "主观题得分";
          } else {
            //不需要批阅
            i.label = "主观题总分";
            i.value = data.report_info.subject_sum_score;
            i.unit = "分";
          }
        }
        if (i.id == "is_pass") {
          //已批阅或者已提交(不需要人工批阅就是已提交)的时候
          if (
            data.report_info.test_status == 1 ||
            data.report_info.test_status == 3
          ) {
            i.value = data.report_info.is_pass == 1 ? "已通过" : "未通过";
            i.type = data.report_info.is_pass;
          } else {
            i.value = "-";
          }
        }
      });
      //右侧答题卡信息
      this.scantron.data = data.card_info;
      //数据处理
      //题目list
      let newData = [];
      for (let i = 0; i < data.question.length; i++) {
        if (data.question[i].children && data.question[i].children.length > 0) {
          let newList = data.question[i].children;
          for (let j = 0; j < newList.length; j++) {
            newData.push({
              ...newList[j],
              parent_ques_stem: data.question[i].ques_stem,
            });
          }
        } else {
          newData.push(data.question[i]);
        }
      }
      let parent_id = "";
      console.log(data);
      newData.forEach((ques, index) => {
        if (ques.parent_id != parent_id) {
          parent_id = ques.parent_id;
          ques.is_sub_first = true;
          if (index > 0) {
            newData[index - 1].is_sub_last = true;
          }
        }
        ques.ques_type = ques.question_type;
        ques.question_id = ques.id;
        ques.index = index + 1;
        if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
          ques.ques_option = JSON.parse(ques.ques_option);
        }
        if (ques.ques_type == 1 || ques.ques_type == 2) {
          let id = ques.ques_option.filter(o => o.is_right == 1)[0].id;
          this.$set(this.answer, ques.question_id, id);
        } else if (ques.ques_type == 3 || ques.ques_type == 4) {
          let ids = [];
          ques.ques_option
            .filter(o => o.is_right == 1)
            .forEach(o => {
              ids.push(o.id);
            });
          this.$set(this.answer, ques.question_id, ids);
        } else if (ques.ques_type == 7) {
          this.$set(
            this.answer,
            ques.question_id,
            ques.right_answer.map(item =>
              Array.isArray(item) ? item.join("、") : item,
            ),
          );
        }
        this.$set(this.showQuestion, ques.index, true);
        this.ids.push(ques.index);
      });
      this.scantron.data.forEach(t => {
        if (!t.child) {
          return;
        }
        t.child.forEach((ques, index) => {
          if (index == 0) {
            this.$set(this.section, ques.sort, {
              name: t.name,
              introduce: t.introduce,
            });
          }
          ques.onlyError = ques.status == 2 || ques.status == 4;
        });
        t.onlyErrorCount = t.child.filter(q => q.onlyError).length;
      });
      this.list = newData || [];
      this.$nextTick(async () => {
        this.showContent();
        let size = 20;
        let count = parseInt(this.ids.length / size);
        if (this.ids.length % size > 0) {
          count++;
        }
        for (let i = 0; i < count; i++) {
          let showIds = this.ids.slice(i * size, (i + 1) * size);
          setTimeout(() => {
            window.MathJax.typesetPromise(showIds.map(id => ".question-" + id));
          }, 10);
        }
      });
    },
    //筛选
    handleCommand(id) {
      this.$router.push({
        name: "TestAnalysis",
        params: { id: id },
      });
    },
    async showContent() {
      let $ = window.$;
      let placeholderOffset = $(this.$refs.placeholder).offset();
      let height = this.$refs.scroll.$el.offsetHeight;

      if (placeholderOffset.top - 118 - 10 > height) {
        return;
      }
      let showId;
      for (let i = 0; i < this.ids.length; i++) {
        let id = this.ids[i];
        if (!this.showQuestion[id]) {
          showId = id;
          break;
        }
      }
      if (showId) {
        this.showQuestion[showId] = true;
        await this.$nextTick();
        await window.MathJax.typesetPromise([".question-" + showId]);
        this.showContent();
      }
    },
    setFixed() {
      let $ = window.$;
      if ($(window).scrollTop() + 84 > 203) {
        this.fixed = true;
        this.fixedRight = ($(window).width() - 1200) / 2;
        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    },
    async scrollTo(id, quesInfo) {
      //判断当前题目有没有展示，没有展示，就不定位
      const data = this.questionList.find(
        item => quesInfo.question_id == item.question_id,
      );
      if (!data) {
        return;
      }
      if (!this.showQuestion[id]) {
        this.showQuestion[id] = true;
        await this.$nextTick();
        await window.MathJax.typesetPromise([".question-" + id]);
      }
      let $ = window.$;
      let top =
        $("#" + id).offset().top + $(this.scrollbarWrap).scrollTop() - 118;
      $(this.scrollbarWrap).scrollTop(top);
      let ids = [];
      for (let i = 1; i < id; i++) {
        if (this.showQuestion[i]) {
          continue;
        }
        this.showQuestion[i] = true;
        ids.push(i);
      }
      await this.$nextTick();
      ids.forEach(i => {
        setTimeout(async () => {
          await window.MathJax.typesetPromise([".question-" + i]);
        }, 1);
      });
    },
    async goRepeat() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 30px;
  .f-left {
    width: 890px;
  }
  .paper-head {
    position: relative;
    background: #fff;
    padding: 0 30px;
    .paper-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333;
      text-align: center;
      padding: 24px 0 16px 0;
      height: 26px;
      line-height: 26px;
      max-width: 770px;
      margin-left: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .paper-info {
      padding-bottom: 7px;
      border-bottom: 1px dashed #e5e5e5;
      display: flex;
      flex-wrap: wrap;
      //justify-content: space-between;
      .paper-info-class {
        max-width: 255px;
        min-width: 207px;
        height: 24px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 12px;
        .label {
          color: #999999;
        }
        .value {
          color: #333;
        }
        .type-1 {
          color: #30c596;
        }
        .type-2 {
          color: #ff2d28;
        }
      }
    }
    .test-status {
      font-size: 32px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: #ff2424;
      line-height: 30px;
      position: absolute;
      top: 20px;
      right: 30px;
      img {
        width: 38px;
        height: 15px;
      }
      .status-icon {
        //position: absolute;
        //top: 115px;
        //right: 38px;
        img {
          width: 96px;
          height: 45px;
        }
      }
    }
  }
  .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
  }

  /deep/ {
    .el-scrollbar__wrap {
      border-radius: 5px;
      overflow-x: hidden;
    }
    .el-scrollbar__thumb {
      background-color: #bfbfbf;
    }
    .question {
      border: none;
      border-radius: 5px;
      background-color: white;
      padding: 20px 34px 0 56px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .question-sub:not(.question-sub-last) {
      margin-bottom: 0 !important;
    }
    .question-sub:not(.question-sub-first) {
      padding-top: 0 !important;
    }
  }
}
.section {
  .title {
    background-color: #f7f7f7;
    padding: 16px 25px;
    font-size: 18px;
    color: #262626;
    span {
      margin-right: 5px;
    }
  }
}
.section-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 1;
  margin-bottom: 20px;
}
.section-introduce {
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
  line-height: 1;
  margin-bottom: 20px;
}
.btn-retry {
  margin: 20px;
  height: 36px;
  background: $primary-color;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: $primary-color-hover;
  }
}
.answer-view {
  border: 1px solid rgba(233, 236, 236, 1);
  border-radius: 5px;
  margin: 19px 20px;
  .title {
    height: 40px;
    background: rgba(245, 245, 245, 1);
    line-height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    padding: 0 18px;
    display: flex;
    justify-content: space-between;
    .q-num {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #333;
    }
  }
  .nums {
    padding-left: 14px;
    max-height: calc(100vh - 70px - 48px - 19px - 40px - 85px - 56px);
    overflow-y: auto;
    .num {
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
    .section {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
      padding-top: 7px;
    }
  }
  .num {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    line-height: 28px;
    display: inline-block;
    text-align: center;
    border: 1px solid rgba(191, 191, 191, 1);
    border-radius: 3px;
    color: #333333;
    margin-bottom: 15px;
    margin-right: 13px;
    cursor: pointer;
    &.num-1 {
      background-color: #30c596;
      border-color: #30c596;
      color: white;
    }
    &.num-2 {
      background-color: #ff2d28;
      border-color: #ff2d28;
      color: white;
    }
    &.num-4 {
      background-color: #17a9fc;
      border-color: #17a9fc;
      color: white;
      &.approve-1 {
        background-color: #00ceb5;
        border-color: #00ceb5;
        color: white;
      }
      &.approve-2 {
        color: #fff;
        background-color: #ffc824;
        border-color: #ffc824;
      }
      &.noApprove {
        color: #fff;
        background-color: #ffc824;
        border-color: #ffc824;
      }
      &.approve {
        color: #fff;
        background-color: #00ceb5;
        border-color: #00ceb5;
      }
    }
  }
  .legend {
    display: flex;
    flex-wrap: wrap;
    padding: 21px 19px 6px 14px;
    align-items: center;
    .num {
      margin-right: 5px;
      width: 14px;
      height: 14px;
      border-radius: 2px;
      cursor: default;
    }
    .text {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
      margin-bottom: 15px;
      white-space: nowrap;
      &:nth-child(2) {
        margin-right: 26px;
      }
      &:nth-child(4) {
        margin-right: 26px;
      }
    }
  }
}
.filter {
  margin: 0 20px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  margin-bottom: 13px;
  color: #666666;
  .filter-text {
    display: inline-block;
    vertical-align: middle;
  }
  /deep/ .el-checkbox {
    margin-right: 11px;
  }
  /deep/ .el-checkbox__inner {
    //border: 1px solid #bfbfbf;
    border-color: #bfbfbf;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: $primary-color;
  }
}
</style>
